export type HelpMessage = {
    id: number;
    user_id: number;
    role: 'user' | 'assistant' | string;
    content: string;
    image_ids?: string | null;
    ticket_id?: number | null;
    created_at: string;
};

export type HelpChatResult = {
    reply: string;
    ticket_id: number | null;
    message_id: number;
};

export function parseError(data: unknown, fallback: string): string {
    if (!data || typeof data !== 'object') return fallback;
    const obj = data as Record<string, unknown>;
    const detail = obj.detail;
    if (typeof detail === 'string') return detail;
    if (detail && typeof detail === 'object') {
        const root = (detail as Record<string, unknown>).root;
        if (typeof root === 'string') return root;
        if (root && typeof root === 'object' && root !== null && 'serverError' in root) {
            return String((root as { serverError: unknown }).serverError);
        }
    }
    const errors = obj.errors;
    if (errors && typeof errors === 'object') {
        const root = (errors as Record<string, unknown>).root;
        if (typeof root === 'string') return root;
        if (root && typeof root === 'object' && root !== null && 'serverError' in root) {
            return String((root as { serverError: unknown }).serverError);
        }
    }
    return fallback;
}

export type HelpDocument = {
    id: number;
    title: string;
    kind: string;
    source_filename?: string | null;
    content: string;
    is_active: boolean;
    created_at: string;
    updated_at?: string | null;
    created_by: number;
};

/** Capture #main-content as a JPEG blob (max 1280px wide). */
export async function captureMainContentScreenshot(): Promise<Blob | null> {
    const target = document.getElementById('main-content');
    if (!target) return null;
    try {
        const html2canvas = (await import('html2canvas')).default;
        const canvas = await html2canvas(target, {
            useCORS: true,
            logging: false,
            scale: Math.min(1, 1280 / Math.max(target.scrollWidth, 1)),
        });
        return await new Promise<Blob | null>(resolve => {
            canvas.toBlob(blob => resolve(blob), 'image/jpeg', 0.7);
        });
    } catch {
        return null;
    }
}
